import React, { useState, useEffect } from 'react';
import './style.css'; // Import your custom CSS

const Event = () => {
    const [logMessages, setLogMessages] = useState(['C:\\Users\\Server>_']);

    useEffect(() => {
        const messages = [
            'Starting server...',
            'Loading configuration...',
            'Server running at http://localhost:3000',
            'Database connected successfully!',
            'Awaiting requests...'
        ];

        let index = 0;
        const intervalId = setInterval(() => {
            if (index < messages.length) {
                setLogMessages(logs => [...logs, messages[index]]);
                index++;
            } else {
                clearInterval(intervalId);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="container">
            <h1 className="title">https://admin.antsnest.co.kr</h1>
            <div className="console">
                {logMessages.map((message, index) => (
                    <div key={index}>{message}</div>
                ))}
            </div>
        </div>
    );
};

export default Event;